var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":_vm.color,"height":_vm.currentHeight}})
}
var staticRenderFns = []

export { render, staticRenderFns }